module.exports = __webpack_public_path__ + "img/alert-info-icon.7e9e8345.svg";